import { useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  ClockingRules,
  ClockingRulesCreationPayload,
  ClockingRulesUpdatePayload,
  create,
  fetch,
  get,
  update,
} from '../api/clocking-rules'

export const clockingRuleKeys = {
  create: ['clocking-rules', 'create'] as const,
  update: ['clocking-rules', 'update'] as const,
} as const

//Queries
export const useOneClockingRulesQuery = (
  id?: ClockingRules['_id'],
  options?: QueryOptions<ClockingRules>,
): UseQueryResult<ClockingRules, any> =>
  useResource<ClockingRules>('clocking-rules', get, id, undefined, options)

export const useClockingRulesQuery = (
  filters?: any,
  options?: QueryOptions<ClockingRules[]>,
): UseQueryResult<ClockingRules[], any> =>
  useResources<ClockingRules[], any>('clocking-rules', fetch, filters, options)

//Mutations
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['clocking-rules'])
}

export const useCreateMutation = (): UseMutationResult<
  ClockingRules,
  ClockingRulesCreationPayload
> => useMutation(create, { mutationKey: clockingRuleKeys.create, onSuccess: onMutationSuccess })

export const useUpdateMutation = (): UseMutationResult<ClockingRules, ClockingRulesUpdatePayload> =>
  useMutation(update, {
    mutationKey: clockingRuleKeys.update,
    onSuccess: onMutationSuccess,
  })
